export class SmsNotify {

    constructor() {
        this.$container = $('#c-sms-notify');
        this.isAvailable = false;
        let isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

        if (isIOS && this.$container.length > 0 && window.innerWidth < 992) {
            this.$container.show();
            this.initializeValidation();
            this.isAvailable = true;
        } else if (this.$container.length > 0) {
            this.$container.remove();
            this.isAvailable = false;
        }
    }

    initializeValidation() {
        let _this = this;
        this.$container.find('input[name="telephone"]').on('keyup', function() {
            _this.hideError();
        });
        this.$container.find('input[name="enabled"]').on('change', function() {
            _this.hideError();
        });
    }

    submit() {
        let telephone = this.$container.find('input[name="telephone"]').val();
        let enabled = this.$container.find('input[name="enabled"]').prop('checked');

        this.hideError();

        if (enabled && telephone === '') {
            this.showError();
            return false;
        } else {
            if (telephone === '' || /^[+]+[0-9\s]{6,}$/.test(telephone)) {
                telephone = telephone.replace(/\s+/g, '');
                this.subscribe(enabled, telephone);
            } else {
                this.showError();
                return false;
            }
        }

        return true;
    }

    subscribe(enabled, telephone) {
        let data = {
            enabled: enabled ? 1 : 0,
            telephone: telephone
        };

        $.ajax({
            type: 'POST',
            url: '/api/sms-subscribe/',
            data: JSON.stringify(data),
            contentType: 'application/json'
        });
    }

    showError() {
        this.$container.find('.form-group').append('<span class="sms-error">Please fill in a valid phone number (e.g. +61400555888). The country code is mandatory.</span>');
    }

    hideError() {
        this.$container.find('.form-group .sms-error').remove();
    }
}